<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">
        Storico Operazioni
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="click_indietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>

    <v-card-text>
      <v-data-table :items="items_history" :headers="headers_history">
        <template v-slot:[`item.DATA`]="{ item }">
          {{ formatData(item.DATA) }}
        </template>
        <template v-slot:[`item.ora_inizio`]="{ item }">
          {{ formatData(item.ora_inizio) }}
        </template>
        <template v-slot:[`item.ora_fine`]="{ item }">
          {{ formatData(item.ora_fine) }}
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "HistoryDialogWO",
  components: { SnackbarQV },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    work_order_sel: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      // Array
      headers_history: [
        {
          text: "Data",
          value: "DATA",
          sortable: false,
        },
        {
          text: "Operatore",
          value: "operatore",
          sortable: false,
        },
        {
          text: "Cod. Macchina",
          value: "cod_macchina",
          sortable: false,
        },
        {
          text: "Start",
          value: "ora_inizio",
          sortable: false,
        },
        {
          text: "Stop",
          value: "ora_fine",
          sortable: false,
        },
        {
          text: "Possesso Tablet",
          value: "utente",
          sortable: false,
        },
        {
          text: "Causale",
          value: "tipo_operazione",
          sortable: false,
        },
      ],
      items_history: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        this.getHistoryWO();
      },
    },
  },
  methods: {
    click_indietro() {
      this.$emit("click_indietro");
    },
    formatData(arg) {
      /* Questo metodo serve per formattare la data da stampare
       * nella tabella. Se non c'è nulla resitituisco una stringa
       * di comodo, altrimenti monto una data formattata. */
      if (arg == null || arg == "") {
        return "N/D";
      } else {
        let strRes = "";
        strRes += arg.substr(8, 2);
        strRes += "/";
        strRes += arg.substr(5, 2);
        strRes += "/";
        strRes += arg.substr(0, 4);
        strRes += " ";
        strRes += arg.substr(11, 8);
        return strRes;
      }
    },
    getHistoryWO() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gethistorywo",
          token: localStorage.user_token,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.items_history = Array.from(res.data.history);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );
        });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>